import frMessages from "@/config/i18n/translations/fr"
import enMessages from "@/config/i18n/translations/en"

export default {

  en: {
    name: "English",
    iso: "en_US",
    messages: enMessages,
  },
  fr: {
    name: "Français",
    iso: "fr_FR",
    messages: frMessages,
  },
};